import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-technology-priority-list-component',
  imports: [AgGridAngular, MatDialogModule, MatButtonModule],
  templateUrl: './technology-priority-list-component.html',
  styleUrl: './technology-priority-list-component.css',
})
export class TechnologyPriorityListComponent {
  columns: ColDef[] = [
      { 
        headerName: 'Opérateur', 
        field: 'provider',
        rowDrag: true,
      }, 
      { 
        headerName: 'Zone tarifaire',
        field: 'pricingZone',
      }
    ];

  rowData = [
    { provider: 'Orange', pricingZone: 'c2e' },
    { provider: 'Eurofiber', pricingZone: 'e0' },
    { provider: 'Covage', pricingZone: 'Zone 3' },
  ]
}
